import type { Campaign } from './campaignTypes';
import { cmaOneClickFromLead } from './cmaOneClickFromLead';
import { prospectionMapFirstVisit } from './prospectionMapFirstVisit';

// Adoption campaigns written by hand: one file each in this folder.
export const explicitCampaigns: Record<string, Campaign> = {
  'cma-one-click-from-lead': cmaOneClickFromLead,
  'prospection-map-first-visit': prospectionMapFirstVisit,
};

export const releaseCampaignId = (releaseId: string) => `release-${releaseId}`;
